import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.95 3.92505C20.95 3.3814 20.7021 2.89189 20.3156 2.55375C19.9334 2.21935 19.4405 2.05005 18.95 2.05005L4.95001 2.05005C4.4595 2.05005 3.96658 2.21935 3.5844 2.55375C3.19796 2.89189 2.95001 3.3814 2.95001 3.92505L2.95001 5.67505C2.95001 6.2187 3.19796 6.70821 3.5844 7.04634C3.96658 7.38075 4.4595 7.55005 4.95001 7.55005L18.95 7.55005C19.4405 7.55005 19.9334 7.38075 20.3156 7.04634C20.7021 6.70821 20.95 6.2187 20.95 5.67505L20.95 3.92505ZM20.3156 9.55375C20.7021 9.89189 20.95 10.3814 20.95 10.925L20.95 12.675C20.95 13.2187 20.7021 13.7082 20.3156 14.0463C19.9334 14.3807 19.4405 14.55 18.95 14.55L4.95001 14.55C4.4595 14.55 3.96658 14.3807 3.5844 14.0463C3.19796 13.7082 2.95001 13.2187 2.95001 12.675L2.95001 10.925C2.95001 10.3814 3.19796 9.89189 3.5844 9.55375C3.96658 9.21935 4.4595 9.05005 4.95001 9.05005L18.95 9.05005C19.4405 9.05005 19.9334 9.21935 20.3156 9.55375ZM20.85 17.925C20.85 17.4125 20.6163 16.9497 20.2498 16.629C19.8871 16.3116 19.418 16.15 18.95 16.15L4.95004 16.15C4.48206 16.15 4.01299 16.3116 3.65027 16.629C3.28372 16.9497 3.05004 17.4125 3.05004 17.925L3.05004 19.675C3.05004 20.1875 3.28372 20.6503 3.65028 20.9711C4.01299 21.2884 4.48205 21.45 4.95004 21.45L18.95 21.45C19.418 21.45 19.8871 21.2884 20.2498 20.9711C20.6163 20.6503 20.85 20.1875 20.85 19.675L20.85 17.925Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTableView = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTableView;
